<div class="flex-row w100 gap-16">
  @if (draggable()) {
    <ng-content select='.drag-handler'></ng-content>
  }
  @if (accent()) {
    <div class="flex-row align-center grow gap-4">
      <span class="subheading-2">{{ text() }}</span>
      <span class="subheading-2 on-accent">{{ accent() }}</span>
      @if (info()) {
        <mat-icon class="info-icon" [matTooltip]="info()">info_outline</mat-icon>
      }
    </div>
  } @else {
    <span class="subheading-2 grow">
      {{ text() }}
      @if (info()) {
        <mat-icon class="info-icon" [matTooltip]="info()">info_outline</mat-icon>
      }
    </span>
  }
  <ng-content/>

  @if (filter()) {
    <ng-content select='.filter'></ng-content>
  }

  @if (editable()) {
    <mat-icon
      #menuTrigger="matMenuTrigger"
      [matMenuTriggerFor]="menu"
      class="cursor-pointer" (click)="menuTrigger.openMenu()">more_horiz
    </mat-icon>

    <mat-menu #menu>
      <div class="p-4">
        <div class="flex-col gap-8 px-16 py-4">
          <span class="on-disabled body-2" (click)="$event.stopPropagation()">{{ 'widget_title.theme' | trans }}</span>
          <div class="flex-row gap-4 cursor-pointer" (click)="$event.stopPropagation()">
            @for (i of 7 | range; track i) {
              <div class="color-button{{widget()?.color === i+1 ? '-selected' : ''}} bg-background widget-{{i+1}}"
                   (click)="setTheme(i+1); $event.stopPropagation()"></div>
            }
          </div>
        </div>
      </div>
      <div class="p-4" (click)="$event.stopPropagation()">
        <div class="px-16 py-4 flex-row align-center gap-4 h-40">
          <div class="gap-4 on-error align-center flex-row cursor-pointer"
               (click)="onRemoveWidget(); $event.stopPropagation()">
            <mat-icon>cancel</mat-icon>
            <span>{{ 'widget_title.remove' | trans }}</span>
          </div>
        </div>
      </div>

    </mat-menu>
  }
</div>
